import React from "react";

import { Grid } from "@mui/material";
import { Article, Group, LocalAtm, YouTube } from "@mui/icons-material";

import { CrewStatisticsTypes } from "../types/crew-dashboard";
import { EnhancedMetricCard } from "../../dashboard/components/admin-widgets/AdminDashboard";

interface StatisticsComponentProps {
  crewStats: CrewStatisticsTypes;
}

export const CrewStatistics: React.FC<StatisticsComponentProps> = ({ crewStats }) => {
  return (      
    <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <EnhancedMetricCard
            title="Total Crew"
            value={crewStats.total}
            icon={Group}
            color="#4BA663"
            trend={7}
            subtitle="All Registered Crew"
            />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <EnhancedMetricCard
            title="Streams"
            value={crewStats.streams}
            icon={YouTube}
            color="#EB4335"
            trend={23}
            subtitle="Streams This Month"
            />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <EnhancedMetricCard
            title="Pending Requests"
            value={crewStats.pendingRequests}
            icon={Article}
            color="#757575"
            trend={-12}
            subtitle="Pending Assignment Requests"
            />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <EnhancedMetricCard
            title="Pending Payouts"
            value={crewStats.pendingPayouts}
            icon={LocalAtm}
            color="#757575"
            trend={36}
            subtitle="Pending Crew Payouts"
            />
        </Grid>
    </Grid>
  );
};
